import {
  BUILDING_CATEGORY,
  CLIMATE_CATEGORY,
  DECHETS_COLLECTE_TRAITEMENT,
  ELECTRICITY_CATEGORY,
  FACILITIES_CATEGORY,
  GEOTHERMAL_CATEGORY,
  INDUSTRY_CATEGORY,
  MOBITLIY_CATEGORY,
  POPULATION_CATEGORY,
  POTENTIAL_CATEGORY,
  WASTE_CATEGORY,
} from '@components/panel/tabs/results-tab/result-manager/result-manager.data'
import { HiddenLayerClass, LayerStandard } from '@core/models/layers.model'
import {
  CSV_AREA_LAYER_ORDER,
  CSV_POINT_LAYER_ORDER,
  PROJECT_CITIWATTS,
  PROJECT_COOLLIFE,
  PROJECT_DECHETS_VS,
  PROJECT_OM4A,
  PROJECT_SAPHEA,
} from './constant.data'
import { LAU2, NUTS0, NUTS2, NUTS3, POPULATION } from './scale.data'

export const RASTER_FORMAT = 'raster'
export const CSV_FORMAT = 'csv'
export const VECTOR_FORMAT = 'vector' // ! Not allowed in dataType
export const GEOJSON_FORMAT = 'geojson'

const GFA_TYPE = 'gross_floor_area'
const CP_TYPE = 'construction_periods'
const COOLING_TYPE = 'cooling'
const POTENTIAL_WIND_TYPE = 'potential_wind'
const POTENTIAL_SOLAR_TYPE = 'potential_solar'
const POPULATION_TYPE = 'pop_tot_density'
const SOLAR_POTENTIAL_FIELDS_TYPE = 'solar_potential_fields'
const BUILDING_VOLUMES_TYPE = 'building_volumes'
const VKT_TYPE = 'vkt'
const WASTE_TYPE_0_10 = 'quantite_dechets_0_10'
const WASTE_TYPE_0_100 = 'quantite_dechets_0_100'
const WASTE_TYPE_0_1000 = 'quantite_dechets_0_1000'
const WASTE_TYPE_0_2000 = 'quantite_dechets_0_2000'
const WASTE_TYPE_0_5000 = 'quantite_dechets_0_5000'

const ID_DEFAULT_LAYER = 0 //Do not change! In the backend, if id=0 this indicates that it is not a personal layer

const ZOOM_LEVEL_DETECT_CHANGE = 10

export const LAYERS_ARRAY: LayerStandard[] = [
  // Buildings
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling density total',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cool_tot_curr_density',
    zoomLevel: 0,
    layer_type: 'cool_tot_curr_density',
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/heat/cool_tot_curr_density/raw/master/data/cool_tot_curr_density.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/heat/cool_tot_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2020 baseline',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2020_baseline',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2020_baseline/-/raw/main/data/cooling_need_2020_baseline.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2020_baseline/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2030 baseline',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2030_baseline',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2030_baseline/-/raw/main/data/cooling_need_2030_baseline.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2030_baseline/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2030 moderate efficiency',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2030_moderate_efficiency',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2030_moderate_efficiency/-/raw/main/data/cooling_need_2030_moderate_efficiency.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2030_moderate_efficiency/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2030 high efficiency',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2030_high_efficiency',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2030_high_efficiency/-/raw/main/data/cooling_need_2030_high_efficiency.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2030_high_efficiency/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2040 baseline',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2040_baseline',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2040_baseline/-/raw/main/data/cooling_need_2040_baseline.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2040_baseline/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2040 moderate efficiency',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2040_moderate_efficiency',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2040_moderate_efficiency/-/raw/main/data/cooling_need_2040_moderate_efficiency.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2040_moderate_efficiency/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2040 high efficiency',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2040_high_efficiency',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2040_high_efficiency/-/raw/main/data/cooling_need_2040_high_efficiency.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2040_high_efficiency/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2050 baseline',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2050_baseline',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2050_baseline/-/raw/main/data/cooling_need_2050_baseline.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2050_baseline/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2050 moderate efficiency',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2050_moderate_efficiency',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2050_moderate_efficiency/-/raw/main/data/cooling_need_2050_moderate_efficiency.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2050_moderate_efficiency/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling need 2050 high efficiency',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'cooling_need_2050_high_efficiency',
    zoomLevel: 0,
    layer_type: COOLING_TYPE,
    downloadUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2050_high_efficiency/-/raw/main/data/cooling_need_2050_high_efficiency.tif',
    repoUrl:
      'https://gitlab.com/eu_coollife/space_cooling_need_density_layers/2050_high_efficiency/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_COOLLIFE],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Heat density total',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'heat_tot_curr_density',
    zoomLevel: 0,
    layer_type: 'heat_tot_curr_density', // unity MWh/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/heat/heat_tot_curr_density/raw/master/data/heat_tot_curr_density.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/heat/heat_tot_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Heat density residential sector',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'heat_res_curr_density',
    zoomLevel: 0,
    layer_type: 'heat_res_curr_density', // unity MWh/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/heat/heat_res_curr_density/raw/master/data/heat_res_curr_density.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/heat/heat_res_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Heat density non-residential sector',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'heat_nonres_curr_density',
    zoomLevel: 0,
    layer_type: 'heat_nonres_curr_density', // unity MWh/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/heat/heat_nonres_curr_density/raw/master/data/heat_nonres_curr_density.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/heat/heat_nonres_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Gross floor area total',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'gfa_tot_curr_density',
    zoomLevel: 0,
    layer_type: GFA_TYPE, // unity m2/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/gfa_tot_curr_density/raw/master/data/gfa_tot_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/buildings/gfa_tot_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Gross floor area residential',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'gfa_res_curr_density',
    zoomLevel: 0,
    layer_type: GFA_TYPE, // unity m2/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/gfa_res_curr_density/raw/master/data/gfa_res_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/buildings/gfa_res_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Gross floor area non-residential',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'gfa_nonres_curr_density',
    zoomLevel: 0,
    layer_type: GFA_TYPE, // unity m2/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/gfa_nonres_curr_density/raw/master/data/gfa_nonres_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/buildings/gfa_nonres_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Building volumes total',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'vol_tot_curr_density',
    zoomLevel: 0,
    layer_type: BUILDING_VOLUMES_TYPE, // unity m3/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/vol_tot_curr_density/raw/master/data/vol_tot_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/buildings/vol_tot_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Building volumes residential',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'vol_res_curr_density',
    zoomLevel: 0,
    layer_type: BUILDING_VOLUMES_TYPE, // unity m3/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/vol_res_curr_density/raw/master/data/vol_res_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/buildings/vol_res_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Building volumes non-residential',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'vol_nonres_curr_density',
    zoomLevel: 0,
    layer_type: BUILDING_VOLUMES_TYPE, // unity m3/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/vol_nonres_curr_density/raw/master/data/vol_nonres_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/buildings/vol_nonres_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Share of gross floor area - constructions before 1975',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'ghs_built_1975_100_share',
    zoomLevel: 0,
    layer_type: CP_TYPE, // unity %
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_1975_100_share/raw/master/data/GHS_BUILT_1975_100_share.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_1975_100_share/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Share of gross floor area - constructions between 1975 and 1990',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'ghs_built_1990_100_share',
    zoomLevel: 0,
    layer_type: CP_TYPE, // unity %
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_1990_100_share/raw/master/data/GHS_BUILT_1990_100_share.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_1990_100_share/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Share of gross floor area - constructions between 1990 and 2000',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'ghs_built_2000_100_share',
    zoomLevel: 0,
    layer_type: CP_TYPE, // unity %
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_2000_100_share/raw/master/data/GHS_BUILT_2000_100_share.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_2000_100_share/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Share of gross floor area - constructions between 2000 and 2014',
    category: BUILDING_CATEGORY,
    isSelected: false,
    workspacename: 'ghs_built_2014_100_share',
    zoomLevel: 0,
    layer_type: CP_TYPE, // unity %
    downloadUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_2014_100_share/raw/master/data/GHS_BUILT_2014_100_share.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/buildings/construction_periods/ghs_built_2014_100_share/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },

  // Industry
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Industrial Sites Emissions',
    category: INDUSTRY_CATEGORY,
    isSelected: false,
    workspacename: 'industrial_database_emissions',
    zoomLevel: 0,
    layer_type: 'industrial_database_emissions', // unity tons/year
    order: CSV_POINT_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/raw/master/data/Industrial_Database.csv?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/blob/master/README.md',
    year: 2014,
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Industrial Sites Excess Heat',
    category: INDUSTRY_CATEGORY,
    isSelected: false,
    workspacename: 'industrial_database_excess_heat',
    zoomLevel: 0,
    layer_type: 'industrial_database_excess_heat', // no unity
    order: CSV_POINT_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/raw/master/data/Industrial_Database.csv?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/blob/master/README.md',
    year: 2014,
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Industrial Sites Company Name',
    category: INDUSTRY_CATEGORY,
    isSelected: false,
    workspacename: 'industrial_database_companyname',
    zoomLevel: 0,
    layer_type: 'industrial_database_companyname', // no unity
    order: CSV_POINT_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/raw/master/data/Industrial_Database.csv?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/blob/master/README.md',
    year: 2014,
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Industrial Sites Subsector',
    category: INDUSTRY_CATEGORY,
    isSelected: false,
    workspacename: 'industrial_database_subsector',
    zoomLevel: 0,
    layer_type: 'industrial_database_subsector', // legend : cement, chemical
    order: CSV_POINT_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/raw/master/data/Industrial_Database.csv?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/hotmaps/industrial_sites/industrial_sites_Industrial_Database/blob/master/README.md',
    year: 2014,
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },

  // Population
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population total 2012',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'pop_tot_curr_density',
    zoomLevel: 0,
    layer_type: POPULATION_TYPE, // unity: Person/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/population/pop_tot_curr_density/raw/master/data/pop_tot_curr_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/population/pop_tot_curr_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population total 2020',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'pop_tot_density_2020',
    zoomLevel: 0,
    layer_type: POPULATION_TYPE, // unity: Person/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/population/pop_tot_density_2020/raw/master/data/pop_tot_density_2020.tif',
    repoUrl: 'https://gitlab.com/hotmaps/population/pop_tot_density_2020/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population Valais 2023',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'population_2023',
    zoomLevel: 0,
    layer_type: 'population_csv',
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/population_2023.csv?ref_type=heads', //@TODO: move in another repository
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md', //@TODO: move in another repository
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population total 2030',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'pop_tot_density_2030',
    zoomLevel: 0,
    layer_type: POPULATION_TYPE, // unity: Person/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/population/pop_tot_density_2030/raw/master/data/pop_tot_density_2030.tif',
    repoUrl: 'https://gitlab.com/hotmaps/population/pop_tot_density_2030/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_DECHETS_VS],
  },

  // Mobility
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Motorization rate',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'motorization_rate_nuts2',
    zoomLevel: 0,
    layer_type: 'motorization_rate_nuts2', // unity: car/1000 hab.
    order: CSV_AREA_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/motorization_rate_nuts2/raw/master/data/motorization_rate_nuts2.csv?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/motorization_rate_nuts2/blob/master/README.md',
    dataType: CSV_FORMAT,
    scales: [NUTS2],
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electric Vehicle density',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'default_ev_density',
    zoomLevel: 0,
    layer_type: 'default_ev_density', // unity: EV/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/default_ev_density/raw/master/data/default_ev_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/default_ev_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Charging stations density',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'cs_density',
    zoomLevel: 0,
    layer_type: 'cs_density', // unity: CS/ha
    downloadUrl: 'https://gitlab.com/hotmaps/mobility/cs_density/raw/master/data/cs_density.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/cs_density/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Eurostat Cities Isodistances',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'rasterized_iso_urban',
    zoomLevel: 0,
    layer_type: VKT_TYPE, // unity: km
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/rasterized_iso_urban/raw/master/data/rasterized_iso_urban.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/rasterized_iso_urban/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Additional Cities Isodistances',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'rasterized_iso_rural',
    zoomLevel: 0,
    layer_type: VKT_TYPE, // unity: km
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/rasterized_iso_rural/raw/master/data/rasterized_iso_rural.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/rasterized_iso_rural/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Transborder commuter ratio',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'rasterized_border',
    zoomLevel: 0,
    layer_type: 'rasterized_border', // unity: %
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/rasterized_border/raw/master/data/rasterized_border.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/rasterized_border/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Eurostat Cities ID',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'rasterized_urau',
    zoomLevel: 0,
    layer_type: 'rasterized_urau', // unity: -
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/rasterized_urau/raw/master/data/rasterized_urau.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/rasterized_urau/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Additional  Cities ID',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'rasterized_urau_rural',
    zoomLevel: 0,
    layer_type: 'rasterized_urau_rural', // unity: -
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/rasterized_urau_rural/raw/master/data/rasterized_urau_rural.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/rasterized_urau_rural/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Workplaces from OpenStreetMap',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'work_osm',
    zoomLevel: 0,
    layer_type: 'work_osm', // unity: workplace/ha
    downloadUrl: 'https://gitlab.com/hotmaps/mobility/work_osm/raw/master/data/work_osm.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/work_osm/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Working areas from Corine Land Cover',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'filtered_corine_land_cover',
    zoomLevel: 0,
    layer_type: 'filtered_corine_land_cover', // unity: -
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/filtered_corine_land_cover/raw/master/data/filtered_corine_land_cover.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/filtered_corine_land_cover/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Points Of Interest',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'poi_osm',
    zoomLevel: 0,
    layer_type: 'poi_osm', // unity: POIs/ha
    downloadUrl: 'https://gitlab.com/hotmaps/mobility/poi_osm/raw/master/data/poi_osm.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/poi_osm/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'VKT from gravity model',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'half_gravity',
    zoomLevel: 0,
    layer_type: VKT_TYPE, // unity: km
    downloadUrl:
      'https://gitlab.com/hotmaps/mobility/half_gravity/raw/master/data/half_gravity.tif',
    repoUrl: 'https://gitlab.com/hotmaps/mobility/half_gravity/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },

  // Potentials
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Waste Water Treatment Plants - Power',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'wwtp_2015_csv_power',
    zoomLevel: ZOOM_LEVEL_DETECT_CHANGE,
    layer_type: 'wwtp_power',
    order: CSV_POINT_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/WWTP/raw/master/data/2015/WWTP_2015.csv?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/potential/WWTP/blob/master/README.md',
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Waste Water Treatment Plants - Capacity',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'wwtp_2015_csv_capacity',
    zoomLevel: ZOOM_LEVEL_DETECT_CHANGE,
    layer_type: 'wwtp_capacity',
    order: CSV_POINT_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/WWTP/raw/master/data/2015/WWTP_2015.csv?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/potential/WWTP/blob/master/README.md',
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Agricultural residues',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'agricultural_residues',
    zoomLevel: 0,
    layer_type: 'agricultural_residues', // Unity: PJ
    order: CSV_AREA_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_biomass/raw/master/data/agricultural_residues.csv?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/potential/potential_biomass/blob/master/README.md',
    year: 1970,
    dataType: CSV_FORMAT,
    scales: [NUTS3], // NUTS2 : result not available, LAU2 : No data in result
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Livestock effluents',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'livestock_effluents',
    zoomLevel: 0,
    layer_type: 'livestock_effluents', // Unity: PJ
    order: CSV_AREA_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_biomass/raw/master/data/livestock_effluents.csv?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/potential/potential_biomass/blob/master/README.md',
    year: 1970,
    dataType: CSV_FORMAT,
    scales: [NUTS3], // NUTS2 : result not available, LAU2 : No data in result
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Forest residues',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'forest_residues',
    zoomLevel: 0,
    layer_type: 'forest_residues', // Unity: MWh/year
    order: CSV_AREA_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_biomass/raw/master/data/forest_residues.csv?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/potential_biomass/blob/master/README.md',
    year: 1970,
    // before: dataType: "csv",
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Potential forest',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'potential_forest',
    zoomLevel: 0,
    layer_type: 'potential_forest', // Unity: MWh/year
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_forest/-/blob/master/data/potential_forest.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/potential/potential_forest/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Municipal solid waste',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'solid_waste',
    zoomLevel: 0,
    layer_type: 'solid_waste', // Unity: PJ
    order: CSV_AREA_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_municipal_solid_waste/raw/master/data/solid_waste.csv?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/hotmaps/potential/potential_municipal_solid_waste/blob/master/README.md',
    year: 2011,
    dataType: CSV_FORMAT,
    scales: [NUTS3],
    projects: [PROJECT_CITIWATTS, PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Wind potential at 50 meters',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'wind_50m',
    zoomLevel: 0,
    layer_type: 'wind_50m', // Unity: [m/s]
    downloadUrl: 'https://gitlab.com/hotmaps/potential/potential_wind/raw/master/data/wind_50m.tif',
    repoUrl: 'https://gitlab.com/hotmaps/potential/potential_wind/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Solar radiation on building footprint',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'solar_optimal_total',
    zoomLevel: 0,
    layer_type: 'solar_optimal_total', // Unity: kWh/m2
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_solar/raw/master/data/solar_opt.tif',
    repoUrl: 'https://gitlab.com/hotmaps/potential/potential_solar/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Geothermal potential Heat Conductivity ',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'shallow_geothermal_potential',
    zoomLevel: 0,
    layer_type: 'shallow_geothermal_potential', // Unity: W/mK
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_shallowgeothermal/-/archive/master/potential_shallowgeothermal-master.zip?path=data',
    repoUrl:
      'https://gitlab.com/hotmaps/potential/potential_shallowgeothermal/blob/master/README.md',
    year: 1970,
    // before: dataType: "shp",
    dataType: CSV_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Potential solarthermal collectors - rooftop',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'potential_solarthermal_collectors_rooftop',
    zoomLevel: 0,
    layer_type: SOLAR_POTENTIAL_FIELDS_TYPE, // Unity: MWh/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_solarthermal_collectors_rooftop/raw/master/data/potential_solarthermal_collectors_rooftop.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/potential/potential_solarthermal_collectors_rooftop/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Potential solarthermal collectors - open field',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'potential_solarthermal_collectors_open_field',
    zoomLevel: 0,
    layer_type: SOLAR_POTENTIAL_FIELDS_TYPE, // Unity: MWh/ha
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/potential_solarthermal_collectors_open_field/raw/master/data/potential_solarthermal_collectors_open_field.tif',
    repoUrl:
      'https://gitlab.com/hotmaps/potential/potential_solarthermal_collectors_open_field/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  // I would suggest to only show on of the geothermal layers - in DB integrated as vector and raster - which one do we need for the indicator?
  /*  {id: idDefaultLayer, name: 'Geothermal Potential Hc Class ', category: POTENTIAL_CATEGORY, isSelected: false,
    workspacename: 'potential_shallowgeothermal_hc_class', zoomLevel: 0, ref: ['overall', POTENTIAL_CATEGORY], styleName: 'potential_shallowgeothermal_hc_class', layer_type: defaultLayerType,
description:   gitlabUrl + '/potential/potential_shallowgeothermal/blob/master/README.md'}},*/

  // Climate
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Average temperature',
    category: CLIMATE_CATEGORY,
    isSelected: false,
    workspacename: 'land_surface_temperature',
    zoomLevel: 0,
    layer_type: 'land_surface_temperature', // Unity: °C
    downloadUrl:
      'https://gitlab.com/hotmaps/climate/land_surface_temperature/raw/master/data/land_surface_temperature.tif',
    repoUrl: 'https://gitlab.com/hotmaps/climate/land_surface_temperature/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cooling degree days',
    category: CLIMATE_CATEGORY,
    isSelected: false,
    workspacename: 'cdd_curr',
    zoomLevel: 0,
    layer_type: 'cdd_curr', // Unity: Degree days
    downloadUrl: 'https://gitlab.com/hotmaps/climate/CDD_ha_curr/raw/master/data/CDD_curr.tif',
    repoUrl: 'https://gitlab.com/hotmaps/climate/CDD_ha_curr/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Heating degree days',
    category: CLIMATE_CATEGORY,
    isSelected: false,
    workspacename: 'hdd_curr',
    zoomLevel: 0,
    layer_type: 'hdd_curr', // Unity: Degree days
    downloadUrl: 'https://gitlab.com/hotmaps/climate/HDD_ha_curr/raw/master/data/HDD_curr.tif',
    repoUrl: 'https://gitlab.com/hotmaps/climate/HDD_ha_curr/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Solar radiation',
    category: CLIMATE_CATEGORY,
    isSelected: false,
    workspacename: 'solar_radiation',
    zoomLevel: 0,
    layer_type: 'climate_solar_radiation', // Unity: kWh/m2
    downloadUrl:
      'https://gitlab.com/hotmaps/climate/climate_solar_radiation/raw/master/data/output_solar_radiation.tif',
    repoUrl: 'https://gitlab.com/hotmaps/climate/climate_solar_radiation/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Wind speed',
    category: CLIMATE_CATEGORY,
    isSelected: false,
    workspacename: 'output_wind_speed',
    zoomLevel: 0,
    layer_type: 'output_wind_speed', // Unity: [m/s]
    downloadUrl:
      'https://gitlab.com/hotmaps/climate/climate_wind_speed/raw/master/data/EU_wind_speed_average.tif',
    repoUrl: 'https://gitlab.com/hotmaps/climate/climate_wind_speed/blob/master/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_CITIWATTS, PROJECT_COOLLIFE, PROJECT_SAPHEA],
  },

  // Electricity
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pantagruel buses',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'pantagruel_buses',
    zoomLevel: 0,
    layer_type: 'pantagruel_buses',
    downloadUrl:
      'https://gitlab.com/hotmaps/electricity/pantagruel/-/raw/main/data/pantagruel_buses.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/electricity/pantagruel/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pantagruel lines',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'pantagruel_lines',
    zoomLevel: 0,
    layer_type: 'pantagruel_lines',
    downloadUrl:
      'https://gitlab.com/hotmaps/electricity/pantagruel/-/raw/main/data/pantagruel_lines.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/electricity/pantagruel/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pantagruel transformers',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'pantagruel_transfos',
    zoomLevel: 0,
    layer_type: 'pantagruel_transfos',
    downloadUrl:
      'https://gitlab.com/hotmaps/electricity/pantagruel/-/raw/main/data/pantagruel_transfos.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/electricity/pantagruel/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pantagruel loads',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'pantagruel_loads',
    zoomLevel: 0,
    layer_type: 'pantagruel_loads',
    downloadUrl:
      'https://gitlab.com/hotmaps/electricity/pantagruel/-/raw/main/data/pantagruel_loads.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/electricity/pantagruel/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pantagruel generators',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'pantagruel_gens',
    zoomLevel: 0,
    layer_type: 'pantagruel_gens',
    downloadUrl:
      'https://gitlab.com/hotmaps/electricity/pantagruel/-/raw/main/data/pantagruel_gens.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/hotmaps/electricity/pantagruel/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_CITIWATTS],
  },

  {
    //@todo, find a solution for this case, a defined standard for a layer but there are no actual layer. This is only used for user upload. Maybe could be used by layer returned by scenario
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'IAMC',
    category: 'Scenario Explorer',
    isSelected: false,
    workspacename: 'iamc',
    zoomLevel: 0,
    layer_type: 'IAMC',
    downloadUrl: '',
    repoUrl: '',
    dataType: CSV_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Small and mini hydropower potential',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'small_mini_hydro_potential',
    zoomLevel: 0,
    layer_type: 'small_mini_hydro_potential',
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/small_mini_hydro_potential/-/raw/main/data/africa-small-mini-hydro-potential.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/res-potential/small_mini_hydro_potential/-/blob/main/README.md?ref_type=heads',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Wind speed at 50 meters',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'wind_speed_50m',
    zoomLevel: 0,
    layer_type: 'wind_speed_50m', // Unit: m/s
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/wind_speed_50m/-/raw/main/data/wind_speed_50m.tif?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/res-potential/wind_speed_50m/-/blob/main/README.md?ref_type=heads',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Substations',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'substations_osm',
    zoomLevel: 0,
    layer_type: 'substation_osm',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/substations_osm/-/raw/main/data/africa_substations_osm.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/substations_osm/-/blob/main/README.md?ref_type=heads',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Health facilities',
    category: FACILITIES_CATEGORY,
    isSelected: false,
    workspacename: 'africa_health_facilities',
    zoomLevel: 0,
    layer_type: 'africa_health_facilities',
    downloadUrl:
      'https://gitlab.com/openmod4africa/facilities/africa_health_facilities/-/blob/main/data/Africa_HealthFacilities_Points.geojson?ref_type=heads',
    repoUrl:
      'https://gitlab.com/openmod4africa/facilities/africa_health_facilities/-/blob/main/README.md?ref_type=heads',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Education facilities',
    category: FACILITIES_CATEGORY,
    isSelected: false,
    workspacename: 'africa_education_facilities',
    zoomLevel: 0,
    layer_type: 'africa_education_facilities',
    downloadUrl:
      'https://gitlab.com/openmod4africa/facilities/africa_education_facilities/-/blob/main/data/Africa_educationFacilities_Points.geojson?ref_type=heads',
    repoUrl:
      'https://gitlab.com/openmod4africa/facilities/africa_education_facilities/-/blob/main/README.md?ref_type=heads',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity Transmission And Distribution (low voltage existing lines)',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'electricity_transmission_and_distribution_lv_existing',
    zoomLevel: 0,
    layer_type: 'electricity_transmission_and_distribution_lv_existing',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_lv_existing/-/raw/main/data/electricity_transmission_and_distribution_lv_existing.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_lv_existing/-/blob/main/README.md',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity Transmission And Distribution (low voltage planned lines)',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'electricity_transmission_and_distribution_lv_planned',
    zoomLevel: 0,
    layer_type: 'electricity_transmission_and_distribution_lv_planned',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_lv_planned/-/raw/main/data/electricity_transmission_and_distribution_lv_planned.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_lv_planned/-/blob/main/README.md',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity Transmission And Distribution (medium voltage existing lines)',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'electricity_transmission_and_distribution_mv_existing',
    zoomLevel: 0,
    layer_type: 'electricity_transmission_and_distribution_mv_existing',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_mv_existing/-/raw/main/data/electricity_transmission_and_distribution_mv_existing.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_mv_existing/-/blob/main/README.md',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity Transmission And Distribution (medium voltage planned lines)',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'electricity_transmission_and_distribution_mv_planned',
    zoomLevel: 0,
    layer_type: 'electricity_transmission_and_distribution_mv_planned',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_mv_planned/-/raw/main/data/electricity_transmission_and_distribution_mv_planned.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_mv_planned/-/blob/main/README.md',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity Transmission And Distribution (very high and high voltage existing lines)',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'electricity_transmission_and_distribution_hv_existing',
    zoomLevel: 0,
    layer_type: 'electricity_transmission_and_distribution_hv_existing',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_hv_existing/-/raw/main/data/electricity_transmission_and_distribution_hv_existing.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_hv_existing/-/blob/main/README.md',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity Transmission And Distribution (very high and high voltage planned lines)',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'electricity_transmission_and_distribution_hv_planned',
    zoomLevel: 0,
    layer_type: 'electricity_transmission_and_distribution_hv_planned',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_hv_planned/-/raw/main/data/electricity_transmission_and_distribution_hv_planned.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/electricity_transmission_and_distribution_hv_planned/-/blob/main/README.md',
    isClickable: true,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Night Time Lights',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'africa_night_time_light',
    zoomLevel: 0,
    layer_type: 'africa_night_time_light',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/night-time-light/-/raw/main/data/africa_night_time_light.tif?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/night-time-light/-/blob/main/README.md?ref_type=heads',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
    attributionImage: 'https://eogdata.mines.edu/products/assets/img/eog_full_disk_dark.500px.png',
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Distribution Transformers',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'distribution_transformers',
    zoomLevel: 0,
    layer_type: 'distribution_transformers',
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/distribution_transformers/-/raw/main/data/distribution_transformers.geojson?ref_type=heads',
    repoUrl:
      'https://gitlab.com/openmod4africa/electricity/distribution_transformers/-/blob/main/README.md?ref_type=heads',
    isClickable: false,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Global Horizontal Irradiation - GHI',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'africa_global_horizontal_irradiation',
    zoomLevel: 0,
    layer_type: POTENTIAL_SOLAR_TYPE,
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/global_horizontal_irradiation/-/raw/main/data/africa_global_horizontal_irradiation.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/res-potential/global_horizontal_irradiation.git',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Electricity CO2 emissions - country average',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'emissions_hourly_csv',
    zoomLevel: 0,
    layer_type: 'emissions_hourly_csv',
    order: CSV_AREA_LAYER_ORDER,
    downloadUrl:
      'https://gitlab.com/hotmaps/electricity/load_electricity/electricity_emissions_hourly/raw/master/data/Emissions_hourly.csv?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/hotmaps/electricity/load_electricity/electricity_emissions_hourly/blob/master/README.md',
    year: 2015,
    dataType: CSV_FORMAT,
    scales: [NUTS0],
    projects: [PROJECT_CITIWATTS],
  },

  // Geothermal (SAPHEA)
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cities with district heating',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'european_cities_w_dh',
    zoomLevel: 0,
    layer_type: 'european_cities_w_dh',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/european_cities_w_dh/-/archive/main/european_cities_w_dh-main.zip',
    repoUrl: 'https://gitlab.com/saphea-h2020/european_cities_w_dh/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Cities with geothermal district heating',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'european_cities_w_geothermal_dh',
    zoomLevel: 0,
    layer_type: 'european_cities_w_geothermal_dh',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/european_cities_w_geothermal_dh/-/archive/main/european_cities_w_geothermal_dh-main.zip',
    repoUrl:
      'https://gitlab.com/saphea-h2020/european_cities_w_geothermal_dh/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Heat flow density in europe',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'heat_flow_density_in_europe',
    zoomLevel: 0,
    layer_type: 'heat_flow_density_in_europe',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/heat_flow_density_in_europe/-/archive/main/heat_flow_density_in_europe-main.zip',
    repoUrl: 'https://gitlab.com/saphea-h2020/heat_flow_density_in_europe/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Hot sedimentary aquifer contour',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'hot_sedimentary_aquifer_contour',
    zoomLevel: 0,
    layer_type: 'hot_sedimentary_aquifer_contour',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/hot_sedimentary_aquifer_contour/-/archive/main/hot_sedimentary_aquifer_contour-main.zip',
    repoUrl:
      'https://gitlab.com/saphea-h2020/hot_sedimentary_aquifer_contour/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Hot sedimentary aquifer fill',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'hot_sedimentary_aquifer_fill',
    zoomLevel: 0,
    layer_type: 'hot_sedimentary_aquifer_fill',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/hot_sedimentary_aquifer_fill/-/archive/main/hot_sedimentary_aquifer_fill-main.zip',
    repoUrl: 'https://gitlab.com/saphea-h2020/hot_sedimentary_aquifer_fill/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Neogene basins contour',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'neogene_basins_contour',
    zoomLevel: 0,
    layer_type: 'neogene_basins_contour',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/neogene_basins_contour/-/archive/main/neogene_basins_contour-main.zip',
    repoUrl: 'https://gitlab.com/saphea-h2020/neogene_basins_contour/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Neogene basins fill',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'neogene_basins_fill',
    zoomLevel: 0,
    layer_type: 'neogene_basins_fill',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/neogene_basins_fill/-/archive/main/neogene_basins_fill-main.zip',
    repoUrl: 'https://gitlab.com/saphea-h2020/neogene_basins_fill/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Subsurface temperature isolines at 1000m',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'subsurface_temperature_isolines_1000m', // not in geoserver (10.04.2025)
    zoomLevel: 0,
    layer_type: 'subsurface_temperature_isolines_1000m',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/subsurface_temperature_isolines_1000m/-/archive/main/subsurface_temperature_isolines_1000m-main.zip',
    repoUrl:
      'https://gitlab.com/saphea-h2020/subsurface_temperature_isolines_1000m/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Subsurface temperature isolines at 2000m',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'subsurface_temperature_isolines_2000m',
    zoomLevel: 0,
    layer_type: 'subsurface_temperature_isolines_2000m',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/subsurface_temperature_isolines_2000m/-/archive/main/subsurface_temperature_isolines_2000m-main.zip',
    repoUrl:
      'https://gitlab.com/saphea-h2020/subsurface_temperature_isolines_2000m/-/blob/main/README.md',

    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pan-European temperature distribution at 1000m',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'temperature_distribution_1000m_supT50C',
    zoomLevel: 0,
    layer_type: 'temperature_distribution_1000m_supT50C',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/temperature_distribution_1000m_supT50C/-/archive/main/temperature_distribution_1000m_supT50C-main.zip',
    repoUrl:
      'https://gitlab.com/saphea-h2020/temperature_distribution_1000m_supT50C/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Pan-European temperature distribution at 2000m',
    category: GEOTHERMAL_CATEGORY,
    isSelected: false,
    workspacename: 'temperature_distribution_2000m_supT90C',
    zoomLevel: 0,
    layer_type: 'temperature_distribution_2000m_supT90C',
    downloadUrl:
      'https://gitlab.com/saphea-h2020/temperature_distribution_2000m_supT90C/-/archive/main/temperature_distribution_2000m_supT90C-main.zip',
    repoUrl:
      'https://gitlab.com/saphea-h2020/temperature_distribution_2000m_supT90C/-/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_SAPHEA],
  },

  // Déchets
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Batteries and cells',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'batteries_piles_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_10,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/batteries_piles_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Step sludge',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'boues_de_step_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_1000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/boues_de_STEP_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Compostable / restaurant / organic',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'compostable_restaurant_organique_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_5000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/compostable_restaurant_organique_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Household waste',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'ordures_menageres',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_5000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/ordures_menageres_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Paper and cardboard',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'papier_et_carton_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_1000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/papier_et_carton_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'PET',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'pet_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_100,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/PET_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Plastic',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'plastique_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_100,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/Plastique_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Glass',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'verre_quantite',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_1000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/verre_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Old wood',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'vieux_bois',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_1000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/vieux_bois_quantite.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Biowaste interpolation',
    category: WASTE_CATEGORY,
    isSelected: false,
    workspacename: 'biowaste_interpolation',
    zoomLevel: 0,
    layer_type: WASTE_TYPE_0_2000,
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/data/biowaste_interpolation.csv?ref_type=heads',
    repoUrl:
      'https://gitlab.com/gestion-d-chets-valais/potential_impact_quantity_waste/-/blob/main/README.md',
    dataType: CSV_FORMAT,
    scales: [LAU2],
    projects: [PROJECT_DECHETS_VS],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Partners',
    category: DECHETS_COLLECTE_TRAITEMENT,
    isSelected: false,
    workspacename: 'partners_location',
    zoomLevel: 0,
    layer_type: '', //@TODO: symbology in geoserveur
    downloadUrl:
      'https://gitlab.com/gestion-d-chets-valais/geojson_valais/-/raw/main/data/partners_location.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/gestion-d-chets-valais/geojson_valais/blob/main/README.md',
    isClickable: true, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_DECHETS_VS],
  },

  // Africa
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population total 2020',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'africa_pop_tot_density_2020',
    zoomLevel: 0,
    layer_type: POPULATION_TYPE,
    downloadUrl:
      'https://gitlab.com/openmod4africa/population/africa_pop_tot_density_2020/-/raw/main/data/africa_pop_tot_density_2020.tif?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/population/africa_pop_tot_density_2020/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population total 2025',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'africa_pop_tot_density_2025',
    zoomLevel: 0,
    layer_type: POPULATION_TYPE,
    downloadUrl:
      'https://gitlab.com/openmod4africa/population/africa_pop_tot_density_2025/-/raw/main/data/africa_pop_tot_density_2025.tif?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/population/africa_pop_tot_density_2025/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Population total 2030',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'africa_pop_tot_density_2030',
    zoomLevel: 0,
    layer_type: POPULATION_TYPE,
    downloadUrl:
      'https://gitlab.com/openmod4africa/population/africa_pop_tot_density_2030/-/raw/main/data/africa_pop_tot_density_2030.tif?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/population/africa_pop_tot_density_2030/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Settlement clusters',
    category: POPULATION_CATEGORY,
    isSelected: false,
    workspacename: 'africa_settlement_clusters',
    zoomLevel: 0,
    layer_type: 'africa_settlement_clusters',
    downloadUrl:
      'https://gitlab.com/openmod4africa/population/africa_settlement_clusters/-/raw/main/data/africa_settlement_clusters.gpkg?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/population/africa_settlement_clusters/-/blob/main/README.md?ref_type=heads',
    dataType: GEOJSON_FORMAT,
    isClickable: false,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Wind potential at 50 meters',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'africa_wind_50m',
    zoomLevel: 0,
    layer_type: POTENTIAL_WIND_TYPE, // Unity: [W/m2]
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/potential_wind/raw/main/data/africa_wind_50m.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/res-potential/potential_wind/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Wind potential at 100 meters',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'africa_wind_100m',
    zoomLevel: 0,
    layer_type: POTENTIAL_WIND_TYPE, // Unity: [W/m2]
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/potential_wind/raw/main/data/africa_wind_100m.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/res-potential/potential_wind/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Wind potential at 200 meters',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'africa_wind_200m',
    zoomLevel: 0,
    layer_type: POTENTIAL_WIND_TYPE, // Unity: [W/m2]
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/potential_wind/raw/main/data/africa_wind_200m.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/res-potential/potential_wind/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Solar potential',
    category: POTENTIAL_CATEGORY,
    isSelected: false,
    workspacename: 'africa_solar_potential',
    zoomLevel: 0,
    layer_type: POTENTIAL_SOLAR_TYPE, // Unity: [kWh/kWp]
    downloadUrl:
      'https://gitlab.com/openmod4africa/res-potential/potential_solar/raw/main/data/africa_solar_potential.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/res-potential/potential_solar/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Workplaces from OpenStreetMap',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'workplaces_osm',
    zoomLevel: 0,
    layer_type: 'workplaces_osm',
    downloadUrl:
      'https://gitlab.com/openmod4africa/mobility/workplaces_osm/-/raw/main/data/workplaces_osm.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/mobility/workplaces_osm/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Points of interest from OpenStreetMap',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'points_of_interest_osm',
    zoomLevel: 0,
    layer_type: 'points_of_interest_osm',
    downloadUrl:
      'https://gitlab.com/openmod4africa/mobility/points_of_interest_osm/-/raw/main/data/points_of_interest_osm.tif?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/mobility/points_of_interest_osm/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Travel time to cities',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'travel_time_to_cities',
    zoomLevel: 0,
    layer_type: 'travel_time_to_cities',
    downloadUrl:
      'https://gitlab.com/openmod4africa/mobility/travel_hours/-/raw/main/data/travel_time_to_cities.tif?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/mobility/travel_hours/-/blob/main/README.md',
    dataType: RASTER_FORMAT,
    projects: [PROJECT_OM4A],
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Major roads',
    category: MOBITLIY_CATEGORY,
    isSelected: false,
    workspacename: 'africa_major_roads',
    zoomLevel: 0,
    layer_type: 'africa_major_roads',
    downloadUrl:
      'https://gitlab.com/openmod4africa/mobility/road-network/-/raw/main/data/africa_major_roads.geojson?ref_type=heads&inline=false',
    repoUrl:
      'https://gitlab.com/openmod4africa/mobility/road-network/-/blob/main/README.md?ref_type=heads',
    isClickable: false,
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },

  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    name: 'Localities powered by mini-grids',
    category: ELECTRICITY_CATEGORY,
    isSelected: false,
    workspacename: 'localities_powered_by_minigrids',
    zoomLevel: 0,
    layer_type: '', //@TODO: symbology in geoserveur
    downloadUrl:
      'https://gitlab.com/openmod4africa/electricity/localities-powered-by-mini-grids/-/raw/main/data/localities_powered_by_mini_grid_in_africa.geojson?ref_type=heads&inline=false',
    repoUrl: 'https://gitlab.com/openmod4africa/electricity/localities-powered-by-mini-grids',
    isClickable: false, // Features unavailable on legacy geoserver (2.11.2 ckable: false, // Features unavailable on legacy geoserver (2.11.2 )
    dataType: GEOJSON_FORMAT,
    projects: [PROJECT_OM4A],
  },
]

export const HIDDEN_LAYERS_ARRAY: HiddenLayerClass[] = [
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    workspacename: 'nuts_id_number',
    name: 'nuts_id_number',
    layer_type: 'nuts_id_number',
    downloadUrl: 'https://gitlab.com/hotmaps/nuts_id_number/raw/master/data/nuts_id_number.tif',
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    workspacename: 'lau2_id_number',
    name: 'lau2_id_number',
    layer_type: 'lau2_id_number',
    downloadUrl: 'https://gitlab.com/hotmaps/lau2_id_number/raw/master/data/lau2_id_number.tif',
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    workspacename: 'building_footprint_tot_curr',
    name: 'building_footprint_tot_curr',
    layer_type: 'building_footprint_tot_curr',
    downloadUrl:
      'https://gitlab.com/hotmaps/building_footprint_tot_curr/raw/master/data/building_footprint_tot_curr.tif',
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    workspacename: 'ground_conductivity',
    name: 'ground_conductivity',
    layer_type: 'ground_conductivity',
    downloadUrl:
      'https://gitlab.com/hotmaps/potential/ground_conductivity/raw/master/data/ground_conductivity.tif',
  },
  {
    id: ID_DEFAULT_LAYER, //Do not change! In the backend, if id=0 this indicates that it is not a personal layer
    workspacename: 'population_density',
    name: 'population_density',
    layer_type: POPULATION,
    downloadUrl: 'https://gitlab.com/hotmaps/population_density/raw/main/data/raster_for_test.tif',
  },
]
